import { useSelector } from 'react-redux';
import { Box, Stack, Typography } from '@mui/material';
import RetentionListPage, { LIST_COLORS as C } from './RetentionListPage';
import { EXITED_HEAD } from './retentionTableHeads';
import { EmptyState, SectionCard } from '../components/ui';
import { RT } from '../theme/retentionTheme';
import { getExitedStudents } from '../../../redux/features/retentionSlice';

const ReasonMix = ({ items, color }) =>
  items.length === 0 ? (
    <EmptyState icon="solar:chart-square-linear" title="No exits yet" compact />
  ) : (
    <Stack gap={1.25}>
      {items.map((r) => (
        <Box key={r.label}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="caption" sx={{ fontWeight: 700, color: RT.ink2 }}>
              {r.label}
            </Typography>
            <Typography variant="caption" sx={{ fontWeight: 800 }}>
              {r.count}
            </Typography>
          </Stack>
          <Box sx={{ height: 8, borderRadius: 99, bgcolor: '#EEF0F6', mt: 0.5 }}>
            <Box sx={{ height: 8, borderRadius: 99, bgcolor: color, width: `${r.percent || 0}%` }} />
          </Box>
        </Box>
      ))}
    </Stack>
  );

// /student-journey/exited — closed at stage 12, split unhappy (type 3) vs happy leaving (type 4) (§2.4).
export default function ExitedStudents() {
  const { exited } = useSelector((state) => state.retention);
  const mix = exited?.meta?.reason_mix || {};

  return (
    <RetentionListPage
      title="Exited students"
      icon="solar:logout-3-bold-duotone"
      headers={EXITED_HEAD}
      fetchThunk={getExitedStudents}
      resource={exited}
      endpoint="GET /retention/exited"
      openPath={(row) => `/student-journey/${row.course_enrollment_id}/tracking?stage=12`}
      filterParam="exit_type"
      filters={[
        { label: 'All', value: '' },
        { label: 'Unhappy', value: 3 },
        { label: 'Happy, leaving', value: 4 },
      ]}
      kpis={[
        { key: 'exited', label: 'Exited', icon: 'solar:logout-3-bold-duotone', color: C.indigo },
        { key: 'unhappy', label: 'Unhappy', icon: 'solar:sad-circle-bold-duotone', color: C.red },
        { key: 'happy_leaving', label: 'Happy, leaving', icon: 'solar:smile-circle-bold-duotone', color: C.amber },
        { key: 'winback_due', label: 'Win-back due', icon: 'solar:restart-circle-bold-duotone', color: C.violet },
        { key: 'avg_nps', label: 'Avg NPS', icon: 'solar:star-bold-duotone', color: C.green },
      ]}
      side={[
        <SectionCard key="d" icon="solar:sad-circle-bold-duotone" color={C.red} title="Dissatisfaction reasons">
          <ReasonMix items={mix.dissatisfaction || []} color={C.red} />
        </SectionCard>,
        <SectionCard key="e" icon="solar:smile-circle-bold-duotone" color={C.amber} title="Exit reasons">
          <ReasonMix items={mix.exit || []} color={C.amber} />
        </SectionCard>,
      ]}
    />
  );
}
